/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import { useParams } from 'react-router';
import { useEffect, useRef } from 'react';
import SurveyCreateQuestions from '../lib/questions';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import SurveyCreateFormInfo from '../lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';
import PrimaryButton from 'components/form/buttons/primaryButton';
import OutlineButton from 'components/form/buttons/outLineButton';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function SurveyDetailPage() {
  const { surveyDetail } = useTypedSelector((state) => state.Survey);
  const { surveyDetailRequestAction, surveyQuestionListAction } = useActions();

  const formRef = useRef<{ submitForm: () => void } | null>(null);

  const params: any = useParams();

  useEffect(() => {
    if (params?.id) surveyDetailRequestAction(params?.id);
  }, []);

  useEffect(() => {
    if (surveyDetail?.data?.questions?.length) {
      surveyQuestionListAction(surveyDetail?.data?.questions);
    }
  }, [surveyDetail?.data?.questions?.length]);

  const transformSurveyData = (response: any) => {
    const questionTypeTitles: Record<string, string> = {
      descriptive: 'Open end',
      optional: 'Multiple',
      rate: 'Rating'
    };

    return response.data.questions?.map((question: any) => ({
      id: question.id,
      index: question.index,
      rate: question.rate,
      type: question.type,
      typeTitle: questionTypeTitles[question.type as keyof typeof questionTypeTitles] || question.type,
      translations: question.questionTranslations.map((qt: any) => ({
        language: qt.language,
        title: qt.title
      })),
      options: question.questionOptions.map((option: any) => ({
        id: option.id,
        translations: option.questionOptionTranslations.map((ot: any) => ({
          language: ot.language,
          title: ot.title
        }))
      }))
    }));
  };

  return (
    <S.Container>
      <PageTitle title="Survey" />
      <S.Stack>
        <SurveyCreateFormInfo ref={formRef} data={surveyDetail.data} questions={transformSurveyData(surveyDetail)} />
        <SurveyCreateQuestions data={surveyDetail.data} questions={transformSurveyData(surveyDetail)} isUpdate={true} />
      </S.Stack>

      <S.Actions>
        <OutlineButton link="/panel/survey">Cancel</OutlineButton>
        <PrimaryButton onClick={() => formRef.current?.submitForm()}>Save survey</PrimaryButton>
      </S.Actions>

      <AppLoading loading={surveyDetail.loading} />
    </S.Container>
  );
}
